import { Link } from "react-router";
import { SignupForm } from "@/components/SignupForm";
import { api } from "@/lib/api";
import { t } from "@/lib/i18n";
import { Shell } from "./Login";

/** Selbst-Registrierung neuer Kunden über die Website – Konto startet im Testbetrieb, Logiful schaltet frei */
export function RegisterPage() {
  return (
    <Shell>
      <h1 className="text-[26px] font-semibold tracking-tight">{t("Logiful-Konto anlegen")}</h1>
      <p className="mt-1.5 text-fg-muted">{t("In einer Minute startklar: Shops verbinden, Artikel prüfen, alles einrichten. Logiful meldet sich mit einem Angebot und schaltet nach Vertragsabschluss frei.")}</p>
      <SignupForm submit={(d) => api.register(d)} submitLabel={t("Konto anlegen")} />
      <p className="mt-6 text-[13px] text-fg-muted">
        {t("Schon Kunde?")} <Link to="/login" className="underline hover:text-fg">{t("Anmelden")}</Link>
      </p>
    </Shell>
  );
}
